import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ThermometerSnowflake, ArrowRight } from 'lucide-react';
import { trackGAEvent } from '../../lib/analytics';

const LINK = 'https://www.pepticool.com/discount/Ninja?utm_source=ninjathlete&utm_medium=affiliate&utm_campaign=pepticool_travel_2026';

export const PeptiCoolBanner = ({ utmContent, compact = false }) => {
  const ref = useRef(null);
  const seen = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') return undefined;
    const obs = new IntersectionObserver((entries) => {
      if (!seen.current && entries.some((e) => e.isIntersecting)) {
        seen.current = true;
        trackGAEvent('affiliate_banner_view', { partner: 'pepticool', placement: utmContent, page_path: window.location.pathname });
        obs.disconnect();
      }
    }, { threshold: 0.4 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [utmContent]);

  return (
    <aside
      ref={ref}
      className={`bg-[#141416] border border-zinc-800 border-l-2 border-l-[#C7FA3E] ${compact ? 'p-5' : 'p-6'} flex flex-col sm:flex-row sm:items-center gap-4 justify-between`}
      data-testid={`pepticool-banner-${utmContent}`}
    >
      <div className="min-w-0">
        <p className="text-[#C7FA3E] text-[11px] font-bold uppercase tracking-widest mb-1.5 flex items-center gap-1.5">
          <ThermometerSnowflake className="w-3.5 h-3.5" /> Traveling with temperature-sensitive peptides?
        </p>
        <p className={`text-white font-semibold ${compact ? 'text-sm' : 'text-base'} mb-1`}>
          Keep your storage plan organized on the go — save 20% on PeptiCool with code <span className="text-[#C7FA3E]">Ninja</span>.
        </p>
        <p className="text-zinc-500 text-xs mb-1">
          <Link to="/blogs/article/traveling-with-peptides-temperature-storage-guide" className="text-zinc-300 underline hover:text-[#C7FA3E] transition-colors" data-testid={`pepticool-guide-link-${utmContent}`}>
            Read our peptide travel guide
          </Link>{' '}
          for the full checklist.
        </p>
        <p className="text-zinc-600 text-[10px]">If you buy through this link, NinjAthlete may earn a commission.</p>
      </div>
      <a
        href={`${LINK}&utm_content=${utmContent}`}
        target="_blank"
        rel="sponsored noopener noreferrer"
        className="flex-none inline-flex items-center justify-center gap-2 bg-[#C7FA3E] text-black text-xs font-bold uppercase tracking-widest px-5 py-3.5 hover:opacity-90 transition-opacity"
        data-testid={`pepticool-cta-${utmContent}`}
      >
        See the travel cooler <ArrowRight className="w-3.5 h-3.5" />
      </a>
    </aside>
  );
};
